import { Fragment, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import Layout from '../components/Layout';
import ResaleLayout from '../components/Layout/resale';
import { ResaleListingLayout } from '../components/Layout/resale-listing';
import Providers from '../hooks/contexts';
import Close from '../pages/close';
import NamingPage from '../pages/naming';
import NotFoundPage from '../pages/notFound';
import PartiallyPaid from '../pages/partially-paid';
import PaymentPage from '../pages/payment';
import PaymentConfirmed from '../pages/payment-confirmed';
import PaymentInProcess from '../pages/payment-in-process';
import ResalePage from '../pages/resale';
import { ResaleListingPage } from '../pages/resale-listing';
import ResalePaymentPage from '../pages/resale-payment';
import TicketsPage from '../pages/tickets';

const FIXED_PATH = ':clientUrl/event/:eventId/';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.IngresseCheckout) {
      window.IngresseCheckout.trackPageView();
    }
  }, [location]);

  return  null;
};

const RoutesApp = () => {
  return (
    <BrowserRouter>
      <Providers>
        <RouteChangeTracker />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path={'/close'} element={<Close />} />
            <Route path={`/sso/${FIXED_PATH}`} element={<Fragment />} />
            <Route path={`/tickets/${FIXED_PATH}`} element={<TicketsPage />} />
            <Route path={`/naming/${FIXED_PATH}`} element={<NamingPage />} />
            <Route path={`/payment/${FIXED_PATH}`} element={<PaymentPage />} />
            <Route
              path={`/payment-confirmed/${FIXED_PATH}`}
              element={<PaymentConfirmed />}
            />
            <Route
              path={`/payment-in-process/${FIXED_PATH}`}
              element={<PaymentInProcess />}
            />
            <Route
              path={`/partially-paid/${FIXED_PATH}`}
              element={<PartiallyPaid />}
            />

            <Route path="/*" element={<NotFoundPage />} />
          </Route>

          <Route element={<ResaleListingLayout />}>
            <Route path={'/resale/event/:identifier'} element={<ResaleListingPage />} />
          </Route>

          <Route element={<ResaleLayout />}>
            <Route path={'/resale/:resaleId'} element={<ResalePage />} />
            <Route path={'/resale/:resaleId/payment'} element={<ResalePaymentPage />} />
          </Route>
        </Routes>
      </Providers>
    </BrowserRouter>
  );
};

export default RoutesApp;

